module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 159.7a818772.png";